<template>
  
        <PDialog :showHeader="false" :closable="false" v-model:visible="visivel"  :modal="true">

          <div class="conteudopopupinicial">
            <div class="cnpjcadastrado">
              Este CNPJ já foi cadastrado
            </div>
            <div class="qual">
              Se trata de um: {{emDesenvolvimento ? 'Cliente Em Desenvolvimento': 'Cliente Ficha Cadastral'}}
            </div>
            <div class="pergunta">
              Deseja editá-lo? 
            </div>
          </div>

          <div class="botaoeditar">
            <div class="botaonovo">
              <g-button largura="150px" negritoTexto v-on:click="editarcnpjexistente"> EDITAR</g-button>
            </div>
            <div class="botaoconsultar">
              <g-button tipo="cinza" largura="150px" negritoTexto v-on:click="cancelarcadastrocnpj" >CANCELAR</g-button>
            </div>
          </div>
        </PDialog>


</template>

<script>
import cnpjExistente from './cnpjExistente.js' 
export default cnpjExistente
</script>

<style scoped>
.conteudopopupinicial{
  margin-top: 15px;
  font-family: 'MontSerrat';
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.botaoeditar{
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap:15px;
  margin-top: 15px;
}


</style>
